export default 'v1.2.1-2020030301'



// WEBPACK FOOTER //
// ./src/version.js